import { CSS_PROPERTY, getCssBasedOnRtl, media } from '../../styles';
import styled from 'styled-components';

export const RefContainer = styled.div`
  display: flex;
  justify-content: space-between;

  div:first-child {
    /* Hide scrollbar for Chrome, Safari and Opera */
    &.hide-scroll-bar::-webkit-scrollbar {
      display: none;
    }

    /* Hide scrollbar for IE, Edge and Firefox */
    &.hide-scroll-bar {
      -ms-overflow-style: none; /* IE and Edge */
      scrollbar-width: none; /* Firefox */
    }

    &:focus-visible {
      outline-style: auto;
      outline-width: 5px;
    }
  }
`;

export const VirtualChildContainer = styled.div`
  padding: ${({ theme }) => `0 ${theme.spacing.base.xl}`};

  ${media.mobilePortrait} {
    padding: ${({ theme }) => `0 ${theme.spacing.mobile.xxxl}`};
  }
`;

export const RowDescription = styled.div`
  padding-top: ${({ theme }) => theme.spacing.base.xxs};
  ${({ theme }) => getCssBasedOnRtl(theme, CSS_PROPERTY.PADDING_RIGHT, theme.spacing.base.xxxxl)};
  width: 100%;

  ${media.mobilePortrait} {
    ${({ theme }) => getCssBasedOnRtl(theme, CSS_PROPERTY.PADDING_RIGHT, theme.spacing.mobile.xxxl)};
    padding-top: 0;
  }
`;

export const ToggleRow = styled.div`
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.typography.color.tertiary};
  display: inline-flex;
  margin-bottom: ${({ theme }) => theme.spacing.base.sm};
  padding-bottom: ${({ theme }) => theme.spacing.base.sm};
  width: 100%;

  ${media.mobilePortrait} {
    margin-bottom: ${({ theme }) => theme.spacing.mobile.xl};
    padding-bottom: ${({ theme }) => theme.spacing.mobile.xl};
  }
`;
